var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_656_96",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 20,
    height: 20
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_656_96)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 15,
    width: 20,
    height: 6,
    fill: "#DB5F7B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 7.62311,
    width: 20,
    height: 7.4074,
    fill: "#6FB1D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.215759,
    width: 20,
    height: 7.4074,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRu);
export default __webpack_public_path__ + "static/media/ru.63d773615837376afc7306027ade70ba.svg";
export { ForwardRef as ReactComponent };